import React from 'react';
import { ArrangeIcon, OptimizeIcon, ClearIcon, SelectedIcon } from '../Icons/OverviewIcons.jsx';
import './QuickActions.css';

const QuickActions = ({ cargos, selectedRows, onAction }) => {
  const inactiveCargos = cargos.filter(cargo => !cargo.active).length;
  const selectedInactive = cargos.filter(cargo => 
    selectedRows.has(cargo.uuid) && !cargo.active
  ).length;

  const actions = [
    {
      id: 'arrange-all',
      label: 'Off line cargo management',
      description: `Tablet usage for active loading`,
      icon: <ArrangeIcon size={32} color="currentColor" />,
      color: 'gradient-blue',
      premium: true,
      onClick: () => onAction('arrangeAll')
    },
    {
      id: 'arrange-selected',
      label: 'Off line cargo management',
      description: `Tablet usage for active unloading`,
      icon: <SelectedIcon size={32} color="currentColor" />,
      color: 'gradient-green',
      premium: true,
      onClick: () => onAction('arrangeSelected')
    },
    {
      id: 'optimize',
      label: 'Optimize Layout',
      description: 'AI-arrange for efficiency',
      icon: <OptimizeIcon size={32} color="currentColor" />,
      color: 'gradient-purple',
      premium: true,
      onClick: () => onAction('optimizeLayout')
    },
    {
      id: 'clear-all',
      label: 'Multi-deck arrangement',
      description: 'Deck bundle (train, ship, other)',
      icon: <ClearIcon size={32} color="currentColor" />,
      color: 'gradient-red',
      premium: true,
      onClick: () => onAction('clearAll')
    }
  ];

  return (
    <div className="quick-actions-modern">
      <div className="actions-header">
        <h4 className="actions-title">Enchanced functions</h4>
        <div className="actions-badge">{actions.filter(a => !a.disabled && !a.premium).length} available</div>
      </div>
      
      <div className="actions-grid-modern">
        {actions.map(action => (
          <button
            key={action.id}
            className={`action-card-modern ${action.color} ${action.disabled ? 'disabled' : 'glow'} ${action.premium ? 'premium' : ''}`}
            onClick={action.onClick}
            disabled={action.disabled || action.premium}
            title={action.premium && !action.disabled ? "Upgrade to Premium to access this feature" : ""}
          >
            <div className="action-background"></div>
            <div className="action-content-modern">
              <div className="action-icon-modern">{action.icon}</div>
              <div className="action-text">
                <div className="action-label-modern">
                  {action.label}
                  {action.premium && <span className="premium-badge">Premium</span>}
                </div>
                <div className="action-description-modern">{action.description}</div>
              </div>
              <div className="action-arrow-modern">
                <span>→</span>
              </div>
            </div>
            {!action.disabled && !action.premium && <div className="action-hover-effect"></div>}
            {action.premium && <div className="premium-overlay"></div>}
            {action.premium && !action.disabled && (
              <div className="premium-lock-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="3" y="11" width="18" height="11" rx="2" />
                  <path d="M7 11V7a5 5 0 0110 0v4" />
                </svg>
              </div>
            )}
          </button>
        ))}
      </div>

      {/* Premium upgrade notice */}
      {actions.filter(a => a.premium && !a.disabled).length > 0 && (
        <div className="premium-upgrade-notice">
          <div className="premium-notice-content">
            <span className="premium-notice-icon">🔒</span>
            <span className="premium-notice-text">
              Upgrade to <strong>Premium</strong> to unlock all {actions.filter(a => a.premium && !a.disabled).length} enhanced functions
            </span>
            <button className="premium-upgrade-btn">
              Upgrade Now →
            </button>
          </div>
        </div>
      )}

      {/* Premium features summary 
      <div className="premium-features-summary">
        <h5 className="premium-summary-title">Premium Features Include:</h5>
        <ul className="premium-features-list">
          <li className="premium-feature">
            <span className="feature-icon blue">📱</span>
            <span>Offline cargo management for loading operations</span>
          </li>
          <li className="premium-feature">
            <span className="feature-icon green">📱</span>
            <span>Offline cargo management for unloading operations</span>
          </li>
          <li className="premium-feature">
            <span className="feature-icon purple">🤖</span>
            <span>AI-powered layout optimization</span>
          </li>
          <li className="premium-feature">
            <span className="feature-icon red">🚢</span>
            <span>Multi-deck arrangement for complex logistics</span>
          </li>
        </ul>
      </div> */}
    </div>
  );
};

export default QuickActions;